<template>
  <div class="stack">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-3 font-weight-bolder kova-text">
          What Tech-stack requirement do you want your dev to have?
        </h4>
        <a-select
          mode="multiple"
          class="w-100 mt-4 mb-5"
          size="large"
          v-model="skills"
          placeholder="What skills are required"
        >
          <a-select-option v-for="skillList in skillLists" :key="skillList">{{
            skillList
          }}</a-select-option>
        </a-select>

        <h6 class="mb-3 font-weight-bold text-left">
          Select Job Specializations
        </h6>
        <a-select
          mode="multiple"
          class="w-100 mt-4 mb-5"
          size="large"
          v-model="specializations"
          placeholder="Job specializations"
        >
          <a-select-option
            v-for="specializationlist in specializationlists"
            :key="specializationlist"
            >{{ specializationlist }}</a-select-option
          >
        </a-select>

        <div class="container-fluid px-0 px-md-4 mb-5">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >
                Back
              </button>
            </div>
            <div class="col text-right">
              <button
                class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="next"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "job-stack",
  data() {
    return {
        specializationlists:[
          'Adobe Software Engineers',
          'Agile QA Engineers',
          'Angular Developers',
          'ADK',
          'Android SDK',
          'API Development Specialists',
          'Access API',
          'ActionScrip',
          'AdMob',
          'AI Engineers',
          'Augmented Reality Developers',
          'Automation Developers',
          'AWS',
          'AWS Cloud Engineers',
          'AWS DevOps Engineers',
          'Back-End Developers',
          'Data Architects',
          'Blockchain Developers',
          'CI/CD Engineers',
          'C#',
          'C++',
          'C# .NET',
          'C++ .NET',
          'CSS',
          'CSS3',
          'D3.js',
          'ÐApp',
          'Dart',
          'Data Analysts',
          'Database Developers',
          'Data Engineers',
          'Data Modeling Experts',
          'Data Scientists',
          'Debugging',
          'Php',
          '.Net',
          'Wordpress dev',
          'Design Engineer',
          'DevOps Engineer',
          'Java Developer',
          'Dropbox',
          'DynsmoDB',
          'Eclipse',
          'eCommerce',
          'Elixir',
          'ERP',
          'Ethereum',
          'Ethereum Smart Contract',
          'Express.js',
          'ExtJS',
          'Payment Api',
          'Fintech',
          'Facebook Ads',
          'Facebook API',
          'Financial Software Developers',
          'Firebase',
          'Firmware Engineers',
          'Flutter',
          'Flux',
          'Fortran',
          'Freelance Developers',
          'Full-Stack Developers',
          'Full Stack Java',
          'Full Stack .NET',
          'Full Stack Node.js',
          'Full Stack PHP',
          'Full Stack Python',
          'Game Developers',
          'GatsbyJS',
          'Git',
          'GitFlow',
          'GitHub',
          'Gmail',
          'Go Engineers',
          'Golang',
          'Google Software Engineers',
          'Google AdWords',
          'Google Analytics',
          'Google API',
          'Google Cloud',
          'Google Cloud Platform',
          'GraphQL',
          'Haskell',
          'Healthcare Data Scientists',
          'Heroku',
          'Hive',
          'HTML5',
          'Hybrid App Developers',
          'Hyperledger',
          'IoT Developers',
          'JavaScript Consultants',
          'Javascript React',
          'Javascript Wordpress',
          'JIRA',
          'jQuery',
          'JRuby',
          'JSON Expert',
          'Kotlin',
          'Kubernetes Experts',
          'Linux',
          'Machine Learning Engineers',
          'MailChimp',
          'Mailgun',
          'MERN Stack',
          'Microservices',
          'MongoDB',
          'MS SQL Developers',
          'MySQL',
          'NestJS',
          '.NET',
          'NetBeans',
          '.NET Core',
          'Network Programmers',
          'Neural Network',
          'Next.js',
          'Node.js ',
          'Node.js Consulting Specialists',
          'Nuxt.js',
          'OAuth Experts',
          'Objective-C',
          'Object-Oriented Programming Experts',
          'Oracle',
          'Oracle SQL',
          'Payment Processing',
          'PayPal',
          'PHP',
          'PHP Laravel',
          'PHP MySQL',
          'PHP Unit Testing',
          'PHP Wordpress',
          'PostgreSQL',
          'PowerBI',
          'Python',
          'Python / C#',
          'QA Engineers',
          'QA Analysts',
          'QA Leads',
          'QA Managers',
          'Manual Testers',
          'QA Specialists',
          'QA Testers',
          'Ractive.js',
          'Raspberry Pi',
          'React.js',
          'React.js Development Consultants',
          'React Native',
          'React Node.js',
          'React Web',
          'Redux',
          'Responsive Web Developers',
          'REST API',
          'Ruby',
          'Ruby on Rails',
          'Rust',
          'SEO',
          'Shopify',
          'Shopify API',
          'Scrum',
          'Slack',
          'Smart Contract',
          'Software Architects',
          'Software Consultants',
          'Software Developers',
          'Software Engineers',
          'Solidity',
          'Spring',
          'Spring Boot',
          'SQL',
          'SQL CLR',
          'SQLite',
          'SQL Server',
          'Stripe Api',
          'Technical Writers',
          'Test Automation Engineers',
          'Test Automation Architects',
          'Test-Driven Development Experts',
          'Test Engineers',
          'Test Software Engineers',
          'Trading Software',
          'Trello',
          'Twilio',
          'Twitter',
          'Twitter Bootstrap',
          'TypeScript',
          'UI/UX',
          'UI',
          ' UX',
          ' and Front-End Developers',
          'Unit Testing Experts',
          'UX',
          'Vanilla JS',
          'Vue.js',
          'Vuetify.js',
          'WebObjects',
          'webOS',
          'Windows App',
          'WooCommerce',
          'WordPress',
          'WordPress Plugin',
          'Wordpress Specialists',
          'Wordpress Theme',
          'XHTML',
          'XML',
          'Zappier'
        ],
      
      skillLists: [
        "PHP",
        "Nodejs",
        "Django",
        "Flask",
        "Laravel",
        "Java",
        "C#",
        "C++",
        ".NET",
        "Ruby",
        "Scala",
        "Perl",
        "Symfony",
        "Spring",
        "JSF",
        "Others"
      ],
      skills: this.$store.state.fcjob.fcjobData.skills,
      specializations: this.$store.state.fcjob.fcjobData.specializations ? this.$store.state.fcjob.fcjobData.specializations : []
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { skills, specializations } = this;
      this.$store.commit("fcjob/updateFcJob", {
        skills,
        specializations
      });
      this.$router.push("job-duration");
    },
    skip() {
      this.$router.push("job-duration");
    }
  }
};
</script>
<style scoped>
.control-width {
  width: 600px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
